import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Lenis from '@studio-freight/lenis';
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { FloatingButtons } from "./components/FloatingButtons";
import { HomePage } from "./pages/HomePage";
import { SobreNosotrosPage } from "./pages/SobreNosotrosPage";
import { OfrecimientosPage } from "./pages/OfrecimientosPage";
import { InformacionAdmisionPage } from "./pages/InformacionAdmisionPage";
import { GaleriaPage } from "./pages/GaleriaPage";
import { ArticulosPage } from "./pages/ArticulosPage";
import { ArticuloDetallePage } from "./pages/ArticuloDetallePage";
import { ContactoPage } from "./pages/ContactoPage";

function App() {
  useEffect(() => {
    let animationFrameId;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      animationFrameId = requestAnimationFrame(raf);
    }

    animationFrameId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(animationFrameId);
      lenis.destroy();
    };
  }, []); // Empty deps is correct - Lenis instance should only be created once

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sobre-nosotros" element={<SobreNosotrosPage />} />
          <Route path="/ofrecimientos" element={<OfrecimientosPage />} />
          <Route path="/informacion-admision" element={<InformacionAdmisionPage />} />
          <Route path="/galeria" element={<GaleriaPage />} />
          <Route path="/articulos" element={<ArticulosPage />} />
          <Route path="/articulos/:slug" element={<ArticuloDetallePage />} />
          <Route path="/contacto" element={<ContactoPage />} />
        </Routes>
        <Footer />
        <FloatingButtons />
      </BrowserRouter>
    </div>
  );
}

export default App;
